import React, { useState } from "react";

import { Tooltip } from "../base/tooltip";
import { TooltipModel } from "./utils";

export function ValidationTooltip({
  model,
  children,
  className,
}: {
  model: TooltipModel;
  children: React.ReactNode;
  className?: string;
}) {
  const [hover, setHover] = useState(false);
  const show = (model.forceOpen || hover) && !!model.message;

  return (
    <Tooltip content={model.message} open={show} onOpenChange={setHover}>
      <div className={className ?? "inline-block relative"}>{children}</div>
    </Tooltip>
  );
}
